/*
	for the feature we have manual implementation
	of this compare func, to exclude some filter values
*/

interface GetDisabledProp {
	(props: { metadataDisabled?: boolean; disabled?: boolean }): boolean | undefined;
}

export const getDisabledProp: GetDisabledProp = (props) => {
	return !!(props?.metadataDisabled || props?.disabled);
};
